// extracted by mini-css-extract-plugin
module.exports = {"container":"Reviews-module--container--3_yqL","slide":"Reviews-module--slide--18XBQ"};